import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";
import { useListingViewGate } from "@/hooks/useListingViewGate";

const ListingLeadGate = () => {
  const { open, close, submitted } = useListingViewGate();

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-lg max-h-[90vh] overflow-y-auto p-6 sm:p-8">
        <DialogHeader className="text-left">
          <p className="eyebrow mb-2">Unlock more homes</p>
          <DialogTitle className="font-serif text-2xl md:text-3xl font-light leading-tight">
            Want John's insider details on these homes?
          </DialogTitle>
          <DialogDescription className="font-light">
            Share your info and John will send listing details, showing availability and off-market options.
          </DialogDescription>
        </DialogHeader>
        <InquiryForm compact defaultInterest="Request a Showing" onSubmitted={submitted} />
      </DialogContent>
    </Dialog>
  );
};

export default ListingLeadGate;
